<style lang="less" scoped>
  .td_left {width: 1.6rem;text-align-last: left;text-indent: .06rem;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 0.4rem;}
  .f_red {color: red;margin-right: .03rem;}
  .f_hid {color: #ffffff;margin-right: .03rem;}
  tr,td {border: .01rem solid #f5eeee;padding: .03rem;border-bottom: .01rem solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 0.3rem;}
  .td {margin-left: .2rem;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 4rem;}
  .level /deep/ .el-input {width: 2rem;}
  .ssgj_tr /deep/ .el-input {width: 4rem;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: .2rem;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: .2rem;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -6.24rem;right: -6.24rem;bottom: -6.24rem;left: -6.24rem;height: auto}
  .formBox {padding-bottom: 0.5rem;}
  .btnfixed {margin: 0rem auto;z-index: 19999;}
  .btnfixed .el-button {height: 0.4rem;margin: .1rem auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 0.4rem;background: #f8f4f4;margin-left: 2.4rem;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 0.16rem;height: 0.4rem;line-height: 0.4rem;float: right;margin-left: .1rem;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
  /deep/.hide .el-upload--picture-card {display: none;}
  /deep/.el-dialog {width: 30%;height: 37%;}
  /deep/.dialog-footer {margin-top: 30%; margin-right: 34%;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" :rules="rules" class="formBox">
      <table>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.catid" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in classifydata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked_External_links">外部链接</el-checkbox>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>矿业资讯标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.title" class="input title" @blur="detection(11, 1, form.title)"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="form.level" placeholder="请选择级别" class="select level">
                <el-option v-for="item in level_data" :key="item.value" :label="item.label" :value="item.value" style="z-index: 99;"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>标题图片
          </td>
          <td class="after">
            <el-upload
              v-if="this.$route.path === '/Kyzxgl'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              :file-list="fileList"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              :on-remove="handleRemovePicture"
              @mouseover.native="getPhoUrl"
              :on-exceed="exceed">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
          </td>
        </tr>
        <tr v-if="checked_External_links">
          <td class="td_left"><span v-if="isMandatory('http')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>链接地址
          </td>
          <td class="after">
            <el-form-item>
              <el-input placeholder="请输入内容" v-model="form.http">
                <template slot="prepend">http://www.</template>
              </el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="!checked_External_links">
          <td class="td_left">
            <span v-if="isContentMandatory('content')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>矿业资讯内容
          </td>
          <td class="after">
            <div id="editor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">
            <span v-if="isMandatory('ssgj')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属国家
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.ssgj" placeholder="请选择所属国家" class="select level" :popper-append-to-body="false">
                <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>矿业资讯简介
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" v-model="form.introduce" :rows="2" class="introduce" style="font-size: .16rem;"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('author')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>矿业资讯作者
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.author"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="copyfrom_tr">
          <td class="td_left">
            <span v-if="isMandatory('copyfrom')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>矿业资讯来源
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.copyfrom" placeholder="例如：新华社" class="copyfrom"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="link_tr">
          <td class="td_left">
            <span v-if="isMandatory('fromurl')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>来源链接
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.fromurl" class="copyfrom"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tag_tr">
          <td class="td_left">
            <span v-if="isMandatory('tag')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>关键词(Tag)
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.tag" placeholder="多个关键词请用空格隔开"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发布时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="请选择添加时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
        <!-- <tr class="addtime_tr" v-if="this.$route.path === '/KyzxUpdate'">
          <td class="td_left">
            <span v-if="isMandatory('edittime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>修改时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.edittime" value-format="timestamp" type="datetime" placeholder="请选择修改时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr> -->
      </table>
    </el-form>
    <el-dialog :visible.sync="dialogFormVisible">
      <el-form :model="forms">
        <el-form-item label="审核意见:" style="margin-left:10%;">
          <el-input
            style="margin-left: 70px;margin-top: -33px;width:110%;"
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="forms.textareas"
            center
            >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="modificaNopass">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Kyzxgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/KyzxUpdate' && this.datastatus === false">确定</el-button>
      <el-button type="success" @click="republish" v-else-if="this.$route.path === '/KyzxUpdate' && this.datastatus === true">重新发布</el-button>
      <el-button type="success" @click="isPass()" v-else-if="this.$route.path === '/KyzxLook'">通过</el-button>

      <el-button @click="cancelfn()" v-if="this.$route.path === '/Kyzxgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/KyzxUpdate'">返回</el-button>
      <el-button type="danger" @click="notPass()" v-else-if="this.$route.path === '/KyzxLook'">不通过</el-button>
      <el-button  @click="backtrackLook()" v-if="this.$route.path === '/KyzxLook'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 何宽
 * 矿业资讯后台添加页
 */
import {mapState} from 'vuex'
// import E from 'wangeditor'
export default {
  components: {
  },

  props: ['updataID'],
  data()
  {
    //链接验证规则
    let InputFromurl = (rule, value, callback) =>
    {
      let regtel = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确来源链接，http://www.'))
        else
          callback()
      }
      else
        callback()
    }
    return {
      url: '',
      checked_External_links: false,
      form: {
        catid: null,
        title: '',
        level: '',
        thumb: '',
        ssgj: null,
        content: '',
        introduce: '',
        author: '',
        copyfrom: '',
        fromurl: '',
        tag: '',
        addtime: null,
        edittime: null,
        hits: 0
      },
      forms: {
        textareas: ''
      },
      datastatus: false,
      username: '',
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList: [{url: ''}],
      //审核
      examine: '',
      examineInfo: '',

      dialogFormVisible: false,

      //rules对象的属性名要与表单中prop绑定的名字一致
      rules: {
        fromurl: [
          { validator: InputFromurl, trigger: 'blur' }
        ]
      },
      
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],

      //表名
      tabname: 'dmcn_article_24',
      tabContentname: 'dmcn_article_data_24',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false

    }
  },
  // 根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        console.log(nval)
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    this.username = userInfo.userno
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
    // 先拉数据再创建编辑器，避免回填时 editor 尚未就绪
    await this.isgetData()
    this.$nextTick(() =>
    {
      window.public.createEditor(this)
    })
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        catid: this.form.catid,
        areaid: 0,
        level: this.form.level,
        title: this.form.title,
        ssgj: this.form.ssgj,
        introduce: this.form.introduce,
        tag: this.form.tag,
        keyword: this.form.title,
        author: this.form.author,
        copyfrom: this.form.copyfrom,
        fromurl: this.form.fromurl,
        thumb: this.form.thumb,
        username: this.username,
        addtime: this.form.addtime ? (this.form.addtime / 1000) : (Date.parse(new Date()) / 1000),
        edittime: (Date.parse(new Date()) / 1000),
        status: '3',
        hits: 0,
        examine: this.examine
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'addWithId',
          _major: 11,
          _minor: 2,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
            this.$emit('removeTab')
            this.$store.commit('onIsLb', '1')
          }
        })
      })
    },
    //获取需要修改的数据
    async isgetData()
    {
      if (this.$route.path === '/KyzxUpdate' || this.$route.path === '/KyzxLook')
        await this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 1,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      let p1 = window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.catid = ret[0].catid
        this.form.areaid = ret[0].areaid
        this.form.level = ret[0].level
        this.form.title = ret[0].title
        this.form.introduce = ret[0].introduce
        this.form.tag = ret[0].tag
        this.form.keyword = ret[0].keyword
        this.form.author = ret[0].author
        this.form.copyfrom = ret[0].copyfrom
        this.form.fromurl = ret[0].fromurl
        this.form.hits = ret[0].hits
        this.form.thumb = ret[0].thumb
        this.form.addtime = ret[0].addtime * 1000
        this.form.edittime = ret[0].edittime * 1000
        this.form.status = ret[0].status
        this.form.ssgj = ret[0].ssgj
        this.fileList[0].url = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
        if (ret[0].examine === 4)
          this.datastatus = true
        else
          this.datastatus = false
      })
      let paras1 = {
        cmd: 'query',
        _major: 11,
        _minor: 2,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      // 只写入 form.content（编码态），等 createEditor 创建后再解码回填，避免 editor 未就绪
      let p2 = window.post.getPost(paras1).then((ret) =>
      {
        this.form.content = ret[0].content || ''
      })
      return Promise.all([p1, p2])
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.form.id,
        catid: this.form.catid,
        areaid: 0,
        level: this.form.level,
        title: this.form.title,
        ssgj: this.form.ssgj,
        introduce: this.form.introduce,
        tag: this.form.tag,
        keyword: this.form.title,
        author: this.form.author,
        copyfrom: this.form.copyfrom,
        fromurl: this.form.fromurl,
        hits: +this.form.hits,
        thumb: this.form.thumb,
        addtime: this.form.addtime ? (this.form.addtime / 1000) : (Date.parse(new Date()) / 1000),
        edittime: this.form.edittime ? (this.form.edittime / 1000) : (Date.parse(new Date()) / 1000),
        status: '3'
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 2,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        console.log(objcontent)
        window.post.getPost(objcontent).then((ret) =>
        {
          console.log(ret)
          if (ret.ret === 1)
            this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
            this.dialogVisible = false
            this.$router.push({path: '/Kyzxgl'})
            this.$store.commit('onActiveName', '1')
          }
        }).catch(e => console.log(e))
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Kyzxgl'})
      this.$store.commit('onActiveName', '1')
    },
    backtrackLook()
    {
      this.$router.push({path: '/ToExamine'})
      this.$store.commit('onActiveName', '1')
    },
    // 点击不通过
    notPass()
    {
      this.dialogFormVisible = true
    },
    // 确定不通过
    modificaNopass()
    {
      console.log(this.forms.textareas)
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: 4,
        exuser: this.username,
        extime: (Date.parse(new Date()) / 1000),
        exopinion: this.forms.textareas
      }
      console.log(objcontent)
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToExamine'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: `id = ${this.updataID}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.examineInfo = ret[0].examine
        let userInfo = JSON.parse(localStorage.getItem('userMsg'))
        let examine = null
        if (userInfo.role.includes(1) && this.examineInfo === 1)
          examine = 2
        else if (userInfo.role.includes(2) && this.examineInfo === 2)
          examine = 3
        else if (userInfo.role.includes(3) && this.examineInfo === 3)
          examine = 5
        else if (userInfo.role.includes(0))
          examine = 0
        this.upExamine(examine)
      })
    },
    //修改状态
    upExamine(examine)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: examine,
        exuser: this.username,
        extime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    },
    // 重新发布
    republish()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: 1,
        exuser: '',
        extime: null,
        exopinion: '',
        catid: this.form.catid,
        areaid: 0,
        level: this.form.level,
        title: this.form.title,
        ssgj: this.form.ssgj,
        introduce: this.form.introduce,
        tag: this.form.tag,
        keyword: this.form.title,
        author: this.form.author,
        copyfrom: this.form.copyfrom,
        fromurl: this.form.fromurl,
        hits: +this.form.hits,
        thumb: this.form.thumb,
        addtime: this.form.addtime ? (this.form.addtime / 1000) : (Date.parse(new Date()) / 1000),
        edittime: this.form.edittime ? (this.form.edittime / 1000) : (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        let objcontent = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 2,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '重新发布失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '重新发布成功', type: 'success', customClass: 'mzindex'})
            this.$router.go(-1)
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/KyzxAdd.vue